/**
 * systemLoadedAssets - an array containing loaded packages.
 * Utilizes a hook to SystemJS assets loading.
 * This should be loaded after loading SystemJS and before importing
 * any other assets.
 *
 */
(function() {
	window.systemLoadedAssets = [];
	var systemFetch = System.fetch;
	System.fetch = function(load) {
		var result = systemFetch.call(this, load);
		var moduleName = load.name.split('/');
		if (moduleName.pop() == 'init.js') {
			systemLoadedAssets.push(moduleName.pop());
		}
		return result;
	};
})();

System.import('ext/ni_assets/Resources/Public/Modules/init/init.js')
    .catch(function (e) {
        throw new Error(e);
    });
